import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

const Item = styled.div`
  font-weight: 400;
  line-height: 1.5;
  color: #373a3c;
  text-align: inherit;
  white-space: nowrap;
  background: 0 0;
  outline: none;
  border: 0;
  cursor: pointer;
  padding: ${props => props.divider ? '2px 0' : '3px 20px'};
  margin-bottom: ${props => props.divider ? '3px' : '0'};
  border-bottom: ${props => props.divider ? '1px solid rgba(0,0,0,.15)' : '0'};

  ${props => !props.divider && css`
    '&:hover' {
      color: #fff;
      background-color: #20a0ff;
      border-color: #20a0ff;
      text-decoration: none;
    }
  `}
`

class MenuItem extends React.Component {

  handleClick = e => {
    e.preventDefault()
    this.props.onItemClick(this.props.eventKey)
    this.props.onClick(this.props.eventKey)
  }

  render() {
    const { children, divider } = this.props
    return (
      <Item role='menuitem' tabIndex='-1' onClick={this.handleClick} divider={divider}>
        {children}
      </Item>
    )
  }
}

MenuItem.defaultProps = {
  divider: false,
  onClick: () => {},
  onItemClick: () => {},
}

MenuItem.propTypes = {
  divider: PropTypes.bool,
  onClick: PropTypes.func,
  onItemClick: PropTypes.func,
}

export default MenuItem



// WEBPACK FOOTER //
// ./src/components/widgets/MenuItem.js